import React from 'react'
import { Wrapper, Icon, Title, Description } from './CenterMessage.styles'

interface CenterMessageProps {
  icon?: React.ElementType
  title: string
  description?: string
}

const CenterMessage = (props: CenterMessageProps) => {
  const { icon, title, description } = props

  return (
    <Wrapper>
      {icon && <Icon as={icon} />}
      {title && <Title>{title}</Title>}
      {description && <Description>{description}</Description>}
    </Wrapper>
  )
}

export default CenterMessage
